import React, {
  useEffect,
  useRef,
  useState,
  Suspense,
  lazy,
  useMemo,
} from "react";
import { Grid, Tooltip, Typography } from "@mui/material";
import axios from "axios";
import { config, termsAndConditionsAPI } from "../../../config";
import NotFound from "../../../components/NotFount";
import { Create } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import Layout from "../../../layout/Layout";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Link from "@mui/material/Link";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { LoadingButton } from "@mui/lab";
import AddIcon from "@mui/icons-material/Add";
import DataTable from "react-data-table-component";
import EditLocationOutlinedIcon from "@mui/icons-material/EditLocationOutlined";
import IconButton from "@mui/material/IconButton";
import { MaterialReactTable } from "material-react-table";

function TermsConditionsList() {
  const navigate = useNavigate();

  let tempRefs = useRef(false);

  useEffect(() => {
    if (tempRefs.current === false) {
      return () => {
        tempRefs.current = true;
      };
    }
  }, []);

  let intOffset = 0;
  const limit = 10;
  const [totalCount, setTotalCount] = useState(0);
  const [termsandConditions, setTermsandConditions] = useState([]);

  const [columnName, setColumnName] = useState("");
  const [sortDirection, setSortDirection] = useState("");

  let assetsRef = useRef(false);
  const childRef = useRef();

  const handleEditTermsAndCondition = (id) => {
    navigate(`/termsandconditions/edit/${id}`);
  };

  const [loading, setLoading] = useState(false);
  const [rowsPerPage, setRowsPerPage] = useState(10); //change to 10 after you remove paginationRowsPerPageOptions
  const [currentPage, setCurrentPage] = useState(1);

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [filters, setFilters] = useState([]);
  const [sorting, setSorting] = useState([]);

  useEffect(() => {
    if (tempRefs.current === false) {
      fetchUsers(1, rowsPerPage, 3);
    }
  }, []);

  const fetchUsers = async (
    page,
    rowsPerPage,
    type = 16,
    columnName = "",
    sortDirection = ""
  ) => {
    const data = JSON.stringify({
      intLimit: pageSize,
      intOffset: pageIndex * pageSize,
      txtColumnName: columnName,
      txtSortDirection: sortDirection,
      intType: 16,
      sorting,
    });

    config.method = "POST";
    config.data = data;
    config.url = termsAndConditionsAPI;

    axios(config)
      .then(function (response) {
        setTermsandConditions(response.data["result"]);
        setTotalCount(response.data.totalCount);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  useEffect(() => {
    fetchUsers();
  }, [pageIndex, pageSize, sorting]);

  const handleEditRole = (id) => {
    navigate(`/employee/view/${id}`);
  };

  const columns = useMemo(
    () => [
      {
        accessorKey: "title", // this accesses row.title automatically
        header: "Title",
        enableColumnFilter: false,
      },
      {
        accessorKey: "status", // access status for conditional styling, but show status_name text
        header: "Status",
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <Typography
            className={
              row.original.status === 2 ? "active-status" : "inactive-status"
            }
          >
            {row.original.status_name}
          </Typography>
        ),
      },
      {
        id: "action", // since no accessorKey, provide an id
        header: "Action",
        enableColumnFilter: false,
        Cell: ({ row }) => (
          <IconButton
            color="success"
            onClick={() => handleEditTermsAndCondition(row.original.id)}
            aria-label="edit"
          >
            <EditLocationOutlinedIcon />
          </IconButton>
        ),
      },
    ],
    []
  );

  return (
    <Layout>
      <Grid className="employee-form bold-header">
        <Grid container spacing={3}>
          <Grid
            textAlign="center"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <Typography className="page_title" textAlign="left">
              Terms and Conditions
            </Typography>
            <Breadcrumbs aria-label="breadcrumb">
              <Link underline="hover" color="inherit" href="/dashboard">
                Dashboard
              </Link>
              <Typography color="text.primary">Purchase Order</Typography>
              <Typography color="text.primary">Terms and Conditions</Typography>
              <Typography color="text.primary">List</Typography>
            </Breadcrumbs>
          </Grid>
          <Grid
            textAlign="right"
            item
            className="form-lable"
            xs={12}
            lg={6}
            md={6}
          >
            <LoadingButton
              size="medium"
              variant="contained"
              color="success"
              className="button_first"
              href="/termsandconditions/add"
              startIcon={<AddIcon />}
            >
              Add
            </LoadingButton>
          </Grid>
        </Grid>

        <MaterialReactTable
          columns={columns}
          data={termsandConditions}
          enableGlobalFilter={false}
          enableFullScreenToggle={false}
          enableDensityToggle={false}
          enableColumnFilters={false}
          className="mat-react-tbl"
          state={{
            isLoading: loading,
            pagination: { pageIndex, pageSize },
            sorting,
            columnFilters: filters,
          }}
          manualPagination
          manualSorting
          manualFiltering
          rowCount={totalCount}
          onPaginationChange={(updater) => {
            const paginationState = updater({
              pageIndex,
              pageSize,
            });
            const { pageIndex: newPageIndex, pageSize: newPageSize } =
              paginationState;
            setPageIndex(newPageIndex);
            setPageSize(newPageSize);
          }}
          onSortingChange={setSorting}
          onColumnFiltersChange={setFilters}
          muiTableBodyCellProps={{
            sx: {
              padding: "3px 8px",
              border: "1px solid #ccc",
            },
          }}
          muiTableHeadCellProps={{
            sx: {
              "& input": {
                color: "#fff !important",
                "&::placeholder": {
                  color: "#fff !important",
                  opacity: 1,
                },
              },
              "& .MuiSelect-select": {
                color: "#fff !important", // selected text color
              },
              "& .MuiSelect-icon": {
                color: "#fff !important", // dropdown arrow color
              },
              color: "#fff",
              fontWeight: "bold",
              "& svg": {
                color: "#fff",
              },
              "& .MuiTableSortLabel-root": {
                color: "#495057",
                "&.Mui-active": {
                  color: "#fff",
                  "& .MuiTableSortLabel-icon": {
                    color: "#fff !important",
                  },
                },
              },
              "& .MuiTableSortLabel-icon": {
                color: "#fff !important",
              },
            },
          }}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              borderBottom: "1px solid #ccc",
              backgroundColor: row.index % 2 === 0 ? "#ffffff" : "#e3f2fd",
            },
          })}
          muiTableHeadCellFilterTextFieldProps={{
            sx: {
              "& input": {
                color: "#fff !important", // Change text color
              },
              "& .MuiInput-underline:before": {
                borderBottomColor: "#fff !important", // Change underline color
              },
              "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                borderBottomColor: "#fff !important", // Hover underline color
              },
              "& .MuiInput-underline:after": {
                borderBottomColor: "#fff !important", // Focused underline color
              },
            },
          }}
        />
      </Grid>
    </Layout>
  );
}

export default TermsConditionsList;
